module.exports = __webpack_public_path__ + "static/codemaven_home-621552c11ef60649cd0a4cb246bdda18.jpg";